export const createRoutes = (basePath?: string) => ({
  base: {
    path: basePath,
    fullPath: basePath,
  },
});

export const DATADOG_ENVIRONMENT = import.meta.env.VITE_APP_DATADOG_ENVIRONMENT || '';
export const DATADOG_SERVICE = import.meta.env.VITE_APP_DD_SERVICE || '';
export const DATADOG_APP_ID = import.meta.env.VITE_APP_DATADOG_APP_ID || '';
export const DATADOG_CLIENT_TOKEN = import.meta.env.VITE_APP_DATADOG_CLIENT_TOKEN || '';
export const PACKAGE_JSON_VERSION = import.meta.env.VITE_APP_VERSION || '';

export const EXTRA_SMALL_BREAKPOINT = 768;
export const REPORTING_MINI_APP_ID = 'com.picsart.social.reporting';
export const AI_GENERATED_REPORTING = 'aigenerated';
